/* eslint-disable eqeqeq */

import React, { useEffect, useRef, useState } from 'react';
import { Grid, Paper, Typography, Button, Box, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TableReport, LoadingPage, SimpleDialog, FilterPod, TableItemActionsNew, Icons, ReceiveFile } from 'components';
import { enifyDateTime } from 'utility';
import { useQuery, useCommon, useCommonDispatcher, useGuildsList } from 'hooks';
import { useCategoryList } from './useCategoryList';
import { useStylesColumns } from './style';
import jMoment from 'moment-jalaali';
import { toFilterVOS } from 'components/FilterPod';
import { columns, columnsId } from './Columns';
import { getBusinessCallbackUri, getListInvoice } from '../../services/DetailAccountsServices';
import BusinessCallbackUri from '../../BusinessCallbackUri';
import generateData from './generateData';
import { getDialog } from './DialogContents';
import InvoiceServices from '../services/InvoiceServices';
import InitFilters from './InitFiltering';
import createToast from 'components/Toast/Toast';
import useCustomHook from '../hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';

const Content = ({currencyText}) => {
  
  const {
    targetUserInfo,
    setTargetUserInfo,
    filters,
    setFilters,
    size,
    setSize,
    isOpenDialog,
    setIsOpenDialog,
    selectedRowData,
    setSelectedRowData,
    actionType,
    setActionType,
    businessCallBackUri,
    setBusinessCallBackUri,
    isOpenDialogCallbackUri,
    setIsOpenDialogCallbackUri,
    page, setPage,
    loading, setLoading,
    selectedCheckData, setSelectedCheckData
  } = useCustomHook();
  const actionsList =
    getDynamicObjectAction([
      'followersListInvoicesFinancialBtn',
      'invoicListFinancialPage',
      'exportInvoicListFinancialBtn',
      'paymentInvoicListFinancialBtn',
      'detailInvoicListFinancialBtn',
      'closeGroupInvoicListFinancialBtn',
      'operationInvoicListFinancialBtn',
      'invoiceGuildExportBtn',
      'invoiceGuildCallbackBtn',
      'invoiceGuildOperationBtn',
      'invoiceGuildPaymentBtn',
      'invoiceGuildGroupBtn',
      'followersListFinancialExportPage',
      'followersListFinancialPaymentBtn',
      'followersListFinancialOperationBtn',
      'followersListFinancialCallbackBtn',
      'followersListFinancialGroupInvoiceBtn',
      'callbackInvoicListFinancialBtn',
      'invoiceGuildBtn'
    ])
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const matches = useMediaQuery('(max-width:940px)');

  const classes = useStylesColumns();
  const { businessGuildsList, guildListLoading, getGuildsList } = useGuildsList();
  const { categoryList, categoryLoading, getCategoryList } = useCategoryList();
  const [paramsData, setParamsData] = useState(null);
  const navigate = useNavigate();
  const dialog = useCommon();
  const setDialog = useCommonDispatcher();
  const query = useQuery();
  const tableRef = useRef();
  const ActionTypes = {
    CANCEL: 'cancel',
    CLOSE: 'close',
  };


  useEffect(() => {
    if (query) {
      const tempFilters = [...(filters && filters?.length > 0 ? filters : InitFilters())];

      const guildCodeQuery = query.get('guild');
      if (guildCodeQuery) {
        query.delete('guild');
        updateFilterItem(tempFilters, 'guildId', parseInt(guildCodeQuery));
      }

      const invoiceStatusQuery = query.get('invoiceStatus');
      if (invoiceStatusQuery) {
        query.delete('invoiceStatus');
        updateFilterItem(tempFilters, 'status', invoiceStatusQuery);
      }

      const startDateQuery = query.get('startDate');
      if (startDateQuery) {
        query.delete('startDate');
        updateFilterItem(tempFilters, 'dateRange', jMoment(startDateQuery, 'jYYYY/jM/jD'), 'start');
      }

      const endDateQuery = query.get('endDate');
      if (endDateQuery) {
        query.delete('endDate');
        updateFilterItem(tempFilters, 'dateRange', jMoment(endDateQuery, 'jYYYY/jM/jD'), 'end');
      }

      onFiltersChange([...tempFilters]);

      const tUser = {
        userId: query.get('id') ? query.get('id') : query.get('userId'),
        fullName: query.get('fullName'),
        username: query.get('username'),
        image: query.get('image'),
      };
      if (tUser?.image) {
        tUser.image = atob(tUser.image);
      }

      if (tUser?.userId) {
        setTargetUserInfo(tUser);
      }
    }
  }, []);

  useEffect(() => {
    getCategoryList();
    if (actionsList['invoicListFinancialPage']) {
      getGuildsList();
      getCallBackUri();
    }

  }, []);

  useEffect(() => {
    if (businessGuildsList?.length === 0) return;
    const tempFilters = [...filters];
    const guildFilterIndex = tempFilters.findIndex((f) => f?.keyName === 'guildId');

    if (guildFilterIndex > 0) {
      tempFilters[guildFilterIndex] = {
        ...tempFilters[guildFilterIndex],
        filterProps: {
          ...tempFilters[guildFilterIndex]?.filterProps,
          options: businessGuildsList,
        },
      };

      onFiltersChange([...tempFilters], true);
    }
  }, [businessGuildsList]);


  useEffect(() => {
    if (categoryList?.length === 0) return;
    const tempFilters = [...filters];
    const guildFilterIndex = tempFilters.findIndex((f) => f?.keyName === 'paymentType');

    if (guildFilterIndex > 0) {
      tempFilters[guildFilterIndex] = {
        ...tempFilters[guildFilterIndex],
        filterProps: {
          ...tempFilters[guildFilterIndex]?.filterProps,
          options: categoryList,
        },
      };
      setFilters(tempFilters);
    }
  }, [categoryList]);

  const getList = async (queryParam) => {
    setLoading(true)
    try {
      const filter = toFilterVOS([...filters]);
      const params = {
        page: queryParam ? queryParam?.pageNumber : page,
        size: queryParam ? queryParam?.pageSize : size,
      };



      if (query?.size > 0 && (query.get('userId'))) {
        if (targetUserInfo === null) {
          return {
            data: [],
            page: 1,
            totalCount: 0,
          };
        }
      }
      if (targetUserInfo?.userId) {
        filter.push({
          id: columnsId.useId,
          value: targetUserInfo?.userId,
        });
      }

      let data = {
        page: queryParam ? queryParam?.pageNumber : page,
        size: queryParam ? queryParam?.pageSize : size,
        dateType: filters.find(a => a.keyName === 'dateTimeType').value,
        startDate: filters.reduce((acc, f) =>
          f.keyName === 'dateRange' && f.value?.start
            ? enifyDateTime(f.value.start.format('jYYYY/jMM/jDD'))
            : acc,
          null),
        endDate: filters.reduce((acc, f) =>
          f.keyName === 'dateRange' && f.value?.end
            ? enifyDateTime(f.value.end.format('jYYYY/jMM/jDD'))
            : acc,
          null),
        status: filters.find(a => a.keyName === 'status').value || null,
        minPayableAmount: filters.find(a => a.keyName === 'amountPayable').value.start || null,
        maxPayableAmount: filters.find(a => a.keyName === 'amountPayable').value.end || null,
        invoiceId: filters.find(a => a.keyName === 'invoiceId').value || null,
        paymentTypeId: filters.find(a => a.keyName === 'paymentType').value || null, // نوع پرداخت - محمد اسم دقیق شو باید بهم بگه
        guildId: filters.find(a => a.keyName === 'guildId').value || null, // حساب تفصیلی  - محمد اسم دقیق شو باید بهم بگه
        userId: query.get('id') ? query.get('id') : query.get('userId') || null,
      }

      setParamsData({ ...data });

      const res = await getListInvoice(data);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: queryParam ? queryParam?.pageNumber : page,
          pageSize: queryParam ? queryParam?.pageSize : page,
        });
      }
      setLoading(false)
      return {
        data: list,
        page: queryParam ? queryParam?.pageNumber : page,
        totalCount: res.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true)
      } else {
        if (axios.isAxiosError(error)) {
          setLoading(false)
          return {
            data: [],
            page: queryParam ? queryParam?.pageNumber : page,
            totalCount: 0,
          };
        }
      }

    }
  };


  const getCallBackUri = async () => {
    try {
      const res = await getBusinessCallbackUri({ active: true });
      setBusinessCallBackUri(res.result);
    } catch (error) { }
  };

  const sendSms = async (rowData) => {
    createToast('در انتظار', 'در حال ارسال پیامک', 'info');
    try {
      await InvoiceServices.sendInvoicePaymentSms(rowData.invoiceId);
      createToast('موفق', 'با موفقیت انجام شد', 'success');
    } catch (error) { }
  };

  const callChangeFilter = (newFilters, isFirstCall) => {
    setPage(0)
    setSize(50)
    if (!isFirstCall) {
      setTimeout(() => {
        tableRef?.current?.onChangeTable(true);
      }, 100)
    }

    setFilters(newFilters);
  }

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters, isFirstCall) => {

    const allValuesNull = newFilters.every(item => item.value === null || (item?.value?.start === null && item?.value?.end === null));
    if (allValuesNull) {
      callChangeFilter(newFilters, isFirstCall)
      return;
    }
    let copyTemp = [...newFilters];
    if (copyTemp[0].value === null && copyTemp[1].value.start === null &&
      copyTemp[1].value.end === null) {
      setFilters(copyTemp);
      callChangeFilter(copyTemp, isFirstCall);
    }
    else if (newFilters[0]?.value === null) {
      copyTemp[0].value = null;
      copyTemp[1].value.start = null;
      copyTemp[1].value.end = null;

      callChangeFilter(copyTemp, isFirstCall)
      createToast('خطا', 'جهت اعمال محدوده تاریخ ، می بایست نوع تاریخ انتخاب شود.', 'warning');
      return;
    } else if (newFilters[0].value !== null) {
      if (
        copyTemp[1].value.start === null ||
        copyTemp[1].value.end === null) {
        copyTemp[0].value = null;
        copyTemp[1].value.start = null;
        copyTemp[1].value.end = null;
        createToast('خطا', 'در صورت انتخاب نوع تاریخ ، محدوده تاریخ می بایست انتخاب شود.', 'warning');
        callChangeFilter(copyTemp, isFirstCall)
        return;
      } else {
        callChangeFilter(newFilters, isFirstCall)
      }
    } else {
      callChangeFilter(newFilters, isFirstCall)
    }

  };

  const updateFilterItem = (
    inputFilters = [], // this method changes the source array, do not pass the state!!
    filterIDorKeyName,
    newValue,
    targetValueKey,
  ) => {
    if (!filterIDorKeyName) return inputFilters;
    const filterIndex = inputFilters.findIndex(
      (f) => f.id == filterIDorKeyName || f.keyName == filterIDorKeyName,
    );
    if (filterIndex < 0) return inputFilters;
    if (!targetValueKey) {
      inputFilters[filterIndex] = { ...inputFilters[filterIndex], value: newValue };
    } else if (targetValueKey === 'start') {
      inputFilters[filterIndex] = {
        ...inputFilters[filterIndex],
        value: { ...inputFilters[filterIndex]?.value, start: newValue },
      };
    } else if (targetValueKey === 'end') {
      inputFilters[filterIndex] = {
        ...inputFilters[filterIndex],
        value: { ...inputFilters[filterIndex]?.value, end: newValue },
      };
    }
    return inputFilters;
  };

  const handleCloseDialog = () => {
    setDialog({ title: '', content: '', open: false });
  };

  const onRemoveTargetUser = async () => {
    setTargetUserInfo(null);
    setPage(0)
    setSize(50)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
    if (query) {
      query.delete('username');
      query.delete('userId');
      query.delete('fullName');
      query.delete('image');
    }
  };

  const handleClick = (rd, actionType) => {
    setActionType(actionType);
    setSelectedRowData(rd);
    setIsOpenDialog(true);
  };

  return (
    <>
      <Grid container spacing={0}>

        <Grid item xs={12}>
          {guildListLoading ? (
            <LoadingPage />
          ) : (
            <>
              {targetUserInfo?.userId ? (
                <Grid container justifyContent="space-between" className={classes.toolbar}>
                  <Grid item>
                    <TargetUser
                      classes={classes}
                      targetUserInfo={targetUserInfo}
                      onRemove={onRemoveTargetUser}
                    />
                  </Grid>
                </Grid>
              ) : null}

              <Grid item xs={12}>
                <Box display='flex' justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16, gap: matches ? '5px' : '0' }} className={classes.btnActions}>
                  {(actionsList['invoicListFinancialPage'] || actionsList['followersListInvoicesFinancialBtn'] || actionsList['invoiceGuildBtn']) && (
                    <FilterButton
                      setOpenFilterDialog={setOpenFilterDialog}
                      filters={filters}
                    />
                  )}
                  {(actionsList['invoiceGuildCallbackBtn'] || actionsList['followersListFinancialCallbackBtn'] || actionsList['callbackInvoicListFinancialBtn']) && (
                    <Button
                      onClick={() => setIsOpenDialogCallbackUri(true)}
                      variant="outlined"
                      color="primary"
                      style={{ minWidth: matches ? '100%' : '200px', margin: matches ? '0' : '0 5px' }}
                    >
                      آدرس‌های بازگشت
                    </Button>
                  )}
                  {(actionsList['followersListFinancialExportPage'] || actionsList['exportInvoicListFinancialBtn'] || actionsList['invoiceGuildExportBtn']) && (
                    <ReceiveFile 
                      classBtn={classes.exportBtn}
                      type={'invoice'}
                      paramsData={paramsData}
                      allowedTypesFormat={['CSV', 'XLS']}
                      isFormatExport={true}
                    />
                  )}
                </Box>
                {(actionsList['invoicListFinancialPage'] || actionsList['followersListInvoicesFinancialBtn'] || actionsList['invoiceGuildBtn']) && (
                  <Box>
                    <FilterPod
                      filters={filters}
                      onChange={onFiltersChange}
                      openFilterDialog={openFilterDialog}
                      setOpenFilterDialog={setOpenFilterDialog}
                      handleCloseFilterDialog={handleCloseFilterDialog}
                    />
                  </Box>
                )}
              </Grid>
              {(actionsList['invoicListFinancialPage'] || actionsList['followersListInvoicesFinancialBtn'] || actionsList['invoiceGuildBtn']) && currencyText && (

                <TableReport
                  data={getList}
                  columns={columns(navigate, sendSms, handleClick, actionsList , currencyText)}
                  isLoading={loading}
                  ref={tableRef}
                  selectionOptions={{
                    hasCheckbox: true,
                    seletedCheckData: setSelectedCheckData
                  }}
                  onChange={(ps) => {
                    setPage(ps?.pageNumber)
                    setSize(ps?.pageSize)
                    return getList(ps)
                  }}
                  checkBoxAction={[
                    ...((actionsList['closeGroupInvoicListFinancialBtn'] ||
                      actionsList['followersListFinancialGroupInvoiceBtn'] || actionsList['invoiceGuildGroupBtn']) ? [
                      () => ({
                        isFreeAction: true,
                        icon: () => (
                          <TableItemActionsNew
                            startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
                            title="عملیات گروهی"
                            otherMenus={[
                              {
                                title: 'کنسل کردن گروهی',
                                isShow: true,
                                onClick: () => {
                                  handleClick(selectedCheckData, ActionTypes.CANCEL);
                                },
                              },
                              {
                                title: ' بستن گروهی',
                                isShow: true,
                                onClick: () => {
                                  handleClick(selectedCheckData, ActionTypes.CLOSE);
                                },
                              },
                            ]}
                          />
                        ),
                      }),
                    ] : [])
                  ]}

                />
              )}


            </>
          )}
        </Grid>

      </Grid>

      <SimpleDialog
        fullWidth
        maxWidth="md"
        open={isOpenDialogCallbackUri}
        title="آدرس‌های بازگشت"
        onClose={() => setIsOpenDialogCallbackUri(false)}
      >
        <BusinessCallbackUri data={businessCallBackUri} />
      </SimpleDialog>

      <SimpleDialog
        fullWidth
        maxWidth="lg"
        open={dialog?.open || false}
        title={dialog?.title}
        onClose={handleCloseDialog}
        loading={dialog?.loading || false}
      >
        {dialog?.content}
      </SimpleDialog>
      {
        getDialog(
          actionType,
          selectedRowData,
          setIsOpenDialog,
          isOpenDialog,
          tableRef,
          businessCallBackUri,
        )
      }
    </>
  );
};

const TargetUser = ({ classes, targetUserInfo, onRemove }) => {
  return (
    <Grid container>
      <Paper className={classes.targetUser}>
        <Grid container alignItems="center" className={classes.targetContainer}>
          <Grid item>
            <Grid container className={classes.contentUser}>
              {targetUserInfo?.fullName ? (
                <Typography className={classes.targetFullName}>
                  {targetUserInfo?.fullName}
                </Typography>
              ) : null}
              {targetUserInfo?.username ? (
                <Typography className={classes.targetUsername}>
                  {targetUserInfo.username}
                </Typography>
              ) : null}
              {targetUserInfo?.userId ? (
                <Typography className={classes.targetId}>
                  {targetUserInfo?.username || targetUserInfo?.fullName ? (
                    <div className={classes.dot} />
                  ) : null}
                  شناسه کاربر :‌ {` ${targetUserInfo.userId}`}
                </Typography>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default Content;